const KEY = 'alerte-immo:signup-session'

/** Posé à l'inscription, dans cet onglet seulement. Absent = reconnexion. */
export function markSignupSession() {
  sessionStorage.setItem(KEY, '1')
}

export function isSignupSession() {
  return sessionStorage.getItem(KEY) === '1'
}
